import { createReducer, on } from '@ngrx/store';
import { addSimulacoesListagemCalculadora, addSimulacoesViewCalculadora, getSelectedSimulacoesCalculadora, removeFromSelectedSimulacoesCalculadora, setSelectedSimulacoesCalculadora, setSimulacoesCalculadora } from '../actions/calculadora.action';
import { CalculadoraState } from '.';

export const initialState: CalculadoraState = {
  selectedSimulacoesCalculadora: [],
  simulacoesListagem: [],
  simulacoesView: [],
  attemptedSimulacoesSearch: false
};


export const calculadoraReducer = createReducer(
  initialState,
  on(setSimulacoesCalculadora, (state, { simulacoes }) => ({
    ...state,
    simulacoes,
    attemptedSimulacoesSearch: true
  })),
  on(setSelectedSimulacoesCalculadora, (state, { selectedSimulacoesCalculadora }) => ({
    ...state,
    selectedSimulacoesCalculadora,
  })),
  on (removeFromSelectedSimulacoesCalculadora, (state, { selectedSimulacoesCalculadora }) => ({
    ...state,
    selectedSimulacoesCalculadora: state.selectedSimulacoesCalculadora.filter(simulacao => simulacao !== selectedSimulacoesCalculadora)
  })),
  on(addSimulacoesListagemCalculadora, (state, { simulacoes }) => {
    // Replicate values on simulacaoView
    const newSimulacoesView = state.simulacoesView.map(
      simulacaoView => {
        const simulacaoMatch = simulacoes?.find(simulacaoToAdd => simulacaoToAdd.id === simulacaoView.id);
        return simulacaoMatch ? simulacaoMatch : simulacaoView;
      }
    );
    const simulacoesListagemPrevious = state.simulacoesListagem;
    const simulacoesToAdd = simulacoes.filter(simulacao => {
      return !simulacoesListagemPrevious.find(simulacaoListagemPrevious => simulacaoListagemPrevious.id === simulacao.id)
    });
    return {
      ...state,
      simulacoesListagem: [...state.simulacoesListagem, ...simulacoesToAdd ],
      simulacoesView: newSimulacoesView,
    }
  }),
  on(addSimulacoesViewCalculadora, (state, { simulacoes }) => {
    return {
      ...state,
      simulacoesView: [...state.simulacoesView, ...simulacoes ]
    }
  })
)
